import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import getTakeAwayTransformer from './transformers/order/takeAwaysTransformer';

export default {
  async fetchActualOrders() {
    return window.axios.get(`/orders/kitchen`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getTakeAwayTransformer()
    });
  },
  async takeOrder(orderId: string) {
    return window.axios.patch(`/order/take-order/${orderId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async refuseOrder(orderId: string) {
    return window.axios.patch(`/order/refuse-order/${orderId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async doneOrder(orderId: string) {
    return window.axios.patch(`/order/done/${orderId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async undoneOrder(orderId: string) {
    return window.axios.patch(`/order/undone/${orderId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async doneOrderProduct(orderProductId: string) {
    return window.axios.patch(`/order-product/done/${orderProductId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async undoneOrderProduct(orderProductId: string) {
    return window.axios.patch(`/order-product/undone/${orderProductId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeOrder(orderId: string) {
    return window.axios.delete(`/order/remove/${orderId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  }
};
